import { Component } from 'react';
import AreaOfImprovement from 'legacy/javascripts/components/area_of_improvement.es6.jsx';

class AreasOfImprovement extends Component {
  render() {
    let data = this.props.data;
    let chartHandler = this.props.chartHandler || (() => {});
    return (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'space-around',
        }}
      >
        {data.map(function (area, idx) {
          return (
            <AreaOfImprovement
              id={area.id}
              chartHandler={chartHandler}
              name={area.caption}
              value={area.total}
              icon={area.icon}
              key={idx}
            />
          );
        })}
      </div>
    );
  }
}

export default AreasOfImprovement;
